module.exports = __webpack_public_path__ + "img/product-2-waike.84cc0b2c.png";